import { resultList } from "@omni/ui/components/Search/SearchResults/components/ResultList/resultList.style";
import { tv } from "tailwind-variants";

const base = tv({
    base: []
});

export const SearchResultsStyle = Object.assign(base, {
    resultList: resultList
});
